<template>
  <div @click.stop.prevent="$emit('close')" class="modal-back">
    <div @click.stop class="modal-inner">
      <div
        class="close-btn"
        @click="$emit('close')"
        data-shortcut-esc="palettePopup"
      >
        <span></span>
      </div>
      <h2>
        {{ labelText }}
      </h2>
      <div>
        <div class="common-input">
          <input
            type="text"
            v-model="inputAlt"
          />
        </div>
        <div class="button-box">
          <button @click="insert" class="normal-btn ok">OK</button>
          <button @click="$emit('close')" class="normal-btn cancel">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/constants'
import ShortCutBase from '@/mixins/ShortCutBase'

export default {
  mixins: [
    ShortCutBase
  ],
  props: [
    'ids',
    'defaultAttrs',
    'labelText',
  ],
  data () {
    return {
      attrs: {},
      inputAlt: null,
    }
  },
  mounted () {
    this.attrs = { ...this.defaultAttrs }
    this.inputAlt = this.$utils.string.sanitizeDecode(this.attrs.alt)
  },
  methods: {
    insert () {
      if (this.inputAlt && this.$utils.string.sanitizeEncode(this.inputAlt).length > constants.maxAltLength) {
        return this.$store.commit('showErrorMessagePopup', [`${this.labelText}が長すぎます ※特殊記号は変換後の文字数で計算`])
      }
      // alt テキストの HTML タグを無効にする
      this.$store.commit('updatePart', {
        ...this.ids,
        attrs: { alt: this.$utils.string.sanitizeEncode(this.inputAlt) }
      })
      this.$emit('close')
    }
  },
}
</script>

<style lang="scss" scoped>
.modal-inner {
  color: $commonFontColor;
  width: 400px;
  background:#F8F8F8;
  border-radius: 2px;
  padding: 10px 20px 20px;
  box-shadow: 0 3px 4px rgba(32, 32, 32, 0.3);
  position: relative;
  .close-btn {
    position: absolute;
    display: inline-block;
    width: 35px;
    height: 35px;
    top: 5px;
    right: 5px;
    border: none;
    cursor: pointer;
    background: none;
    outline: none;
    span::before, span::after {
      display: block;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 20px;
      height: 2px;
      border-radius: 2px;
      margin: -1px 0 0 -13px;
      background: #555;
    }
    span::before {
      transform: rotate(-45deg);
    }
    span::after {
      transform: rotate(45deg);
    }
    &:hover {
      opacity: 0.7;
    }
  }
  h2 {
    border-bottom: 1px solid #dbdbdb;
    line-height: 2;
  }
  .common-input {
    width: 400px;
    line-height: 1.3;
    margin: 30px 0;
    padding: 5px 10px 3px 10px;
  }
  .button-box {
    display: flex;
    justify-content: center;
    button {
      font-size: 14px;
      border: solid 1px #c6c6c6;
      border-radius: 5px;
      &:hover {
        opacity: 0.8;
      }
      &.ok {
        margin-right: 20px;
        color: #fff;
        border: solid 1px #484848;
        background: #484848;
      }
    }
  }
}

</style>
